import { Box, Stack } from '@mui/material';

import { url } from '../../appRouter/url';
import { ContentLoading, EasyBreadcrumbs, type EasyBreadcrumbsItem, NoContentInfo } from '../../components/general';
import { useNormalizedParams } from '../../hooks/useNormalizedParams';
import { usePageTitle } from '../../hooks/usePageTitle';
import { trpc } from '../../trpc';
import { VeranstaltungPlanung } from './VeranstaltungPlanung';

export const ThemaVeranstaltungPlanungPage = () => {
  const { akaProduktId } = useNormalizedParams();

  if (akaProduktId === undefined) {
    throw new TypeError('Die Aka-Produkt-Id fehlt in der URL.');
  }

  const themaQuery = trpc.thema.getThemaByAkaProduktId.useQuery(akaProduktId);

  usePageTitle(themaQuery.data && `${themaQuery.data.thema.buchungsnummer} | Veranstaltung anlegen`);

  if (themaQuery.error) {
    return <NoContentInfo content="Veranstaltung konnte nicht gefunden werden" />;
  }

  if (themaQuery.isLoading || !themaQuery.data) {
    return <ContentLoading />;
  }

  const breadcrumbs: EasyBreadcrumbsItem[] = [
    {
      href: url.root(),
      label: 'Dashboard',
    },
    {
      href: url.thema.details(themaQuery.data.thema.akaProduktId),
      label: 'Thema',
    },
    {
      href: '',
      label: 'Veranstaltung anlegen',
    },
  ];

  return (
    <Stack direction="column">
      <Box sx={{ my: 2 }}>
        <EasyBreadcrumbs items={breadcrumbs} />
      </Box>
      <VeranstaltungPlanung thema={themaQuery.data.thema} />
    </Stack>
  );
};
